import { PageLocatorMap } from '../types/PageLocatorMap';

export const activationPinVerifyPage = {
  alert: {
    error: 'activation-pin-verify.alert.error',
    success: 'activation-pin-verify.alert.success',
  },
  footer: {
    root: 'activation-pin-verify.footer',
  },
  form: {
    h1: 'activation-pin-verify.form.heading1',
    h3: 'activation-pin-verify.form.heading3',
    pinInput1: 'activation-pin-verify.form.pin-input-1',
    pinInput2: 'activation-pin-verify.form.pin-input-2',
    pinInput3: 'activation-pin-verify.form.pin-input-3',
    pinInput4: 'activation-pin-verify.form.pin-input-4',
    pinInput5: 'activation-pin-verify.form.pin-input-5',
    pinInput6: 'activation-pin-verify.form.pin-input-6',
    pinInputError: 'activation-pin-verify.form.pin-error',
    resendPinLink: 'activation-pin-verify.form.resend-pin-link',
    root: 'activation-pin-verify.form.root',
  },
  header: {
    root: 'activation-pin-verify.header',
  },
} as const satisfies PageLocatorMap;
